"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileUploader = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireWildcard(require("react"));
var _attachmentDiagonal = require("../../../assets/icons/attachment-diagonal.svg");
var _FormFieldMessage = require("../../form-field/form-field-message/FormFieldMessage");
var _Button = require("../../../elements/button/Button");
var _noop = require("../../../utils/noop");
var _useTranslation2 = require("../../../hooks/useTranslation/useTranslation");
var _fileUploaderModule = _interopRequireDefault(require("./file-uploader.module.scss"));
var _FileItem = require("./file-item/FileItem");
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["onError", "onChange", "value", "maxSizeMb", "disabled", "allowedFileTypes", "instruction", "buttonText", "emptyText", "multiple", "className"];
// helps to narrow value type
function isMultiple(value, multiple) {
  return multiple;
}
var FileUploader = function FileUploader(_ref) {
  var _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? _noop.noop : _ref$onError,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? _noop.noop : _ref$onChange,
    value = _ref.value,
    _ref$maxSizeMb = _ref.maxSizeMb,
    maxSizeMb = _ref$maxSizeMb === void 0 ? 1 : _ref$maxSizeMb,
    disabled = _ref.disabled,
    allowedFileTypes = _ref.allowedFileTypes,
    instruction = _ref.instruction,
    buttonText = _ref.buttonText,
    emptyText = _ref.emptyText,
    multiple = _ref.multiple,
    className = _ref.className,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var fileRef = (0, _react.useRef)(null);
  var hasValue = isMultiple(value, multiple) ? (value === null || value === void 0 ? void 0 : value.length) > 0 : !!(value !== null && value !== void 0 && value.name);
  var handleFileChange = (0, _react.useCallback)(function (_ref2) {
    var target = _ref2.target;
    var file = target.files[0];
    if (file.size > maxSizeMb * 1024 * 1024) {
      return onError({
        error: t('fileUploader.fileSizeError', {
          maxSizeMb: maxSizeMb
        })
      });
    }
    if (isMultiple(value, multiple)) {
      onChange([].concat((0, _toConsumableArray2.default)(value || []), [file]), true);
    } else {
      onChange(file, true);
    }
  }, [maxSizeMb, onError, t, value, multiple, onChange]);
  var handleRemove = (0, _react.useCallback)(function (file) {
    if (isMultiple(value, multiple)) {
      var fileIndex = value.indexOf(file);
      onChange([].concat((0, _toConsumableArray2.default)(value.slice(0, fileIndex)), (0, _toConsumableArray2.default)(value.slice(fileIndex + 1))), true);
    } else {
      onChange(undefined, true);
    }
  }, [value, multiple, onChange]);
  var handleUploadClick = (0, _react.useCallback)(function () {
    fileRef.current && fileRef.current.click();
  }, [fileRef]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "file-uploader"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "file-uploader-container",
    className: (0, _classnames.default)(_fileUploaderModule.default['file-uploader__content-container'], className)
  }, /*#__PURE__*/_react.default.createElement("input", Object.assign({
    "data-testid": "file-input",
    type: "file",
    hidden: true,
    ref: fileRef,
    onChange: handleFileChange
    // TODO: ask why?
    // onClick={(event) => {
    // event.currentTarget.value = null
    // }}
    ,
    accept: allowedFileTypes.join(', ')
  }, rest)), /*#__PURE__*/_react.default.createElement(_Button.StandardButton, {
    "data-testid": "upload-btn",
    onClick: handleUploadClick,
    className: _fileUploaderModule.default['file-uploader__attach-btn'],
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_attachmentDiagonal.ReactComponent, null), buttonText || t('fileUploader.buttonText')), hasValue && !isMultiple(value, multiple) && /*#__PURE__*/_react.default.createElement(_FileItem.FileItem, {
    file: value,
    onRemoveClick: handleRemove
  }), !hasValue && /*#__PURE__*/_react.default.createElement("span", {
    className: _fileUploaderModule.default['file-uploader__empty-text']
  }, emptyText || t('fileUploader.defaultEmptyText'))), /*#__PURE__*/_react.default.createElement("div", null, hasValue && isMultiple(value, multiple) && value.map(function (file, index) {
    return /*#__PURE__*/_react.default.createElement(_FileItem.FileItem, {
      key: index,
      file: file,
      onRemoveClick: handleRemove
    });
  })), /*#__PURE__*/_react.default.createElement(_FormFieldMessage.FormFieldMessage, {
    instruction: instruction
  }));
};
exports.FileUploader = FileUploader;